import * as Sentry from '@sentry/browser';

export default function captureMessage(message) {
  return Sentry.captureMessage(message, (scope) => scope.setExtra('sentInternally', true));
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/public/utils/captureMessage.js